import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '@assets/locales/en/common.json';
import frTranslations from '@assets/locales/fr/common.json';

async function initI18n() {
  await i18n
    .use(initReactI18next)
    .init({
      resources: {
        en: { translation: enTranslations },
        fr: { translation: frTranslations },
      },
      lng: 'en',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    })
    .catch((error: unknown) => {
      console.error('i18n initialization error:', error);
    });
}

void initI18n();

export default i18n;
